export enum AppLanguage {
	HU = "hu",
	EN = "en",
	LV = "lv",
}
